/**
 * Api documentation
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TacticMPOReturnCurveDataPoint } from './tacticMPOReturnCurveDataPoint';


export interface MPOReturnCurveSeriesResponseDTO { 
    /**
     * Fixed mix series type.
     */
    type: MPOReturnCurveSeriesResponseDTO.TypeEnum;
    /**
     * Display label for the series.
     */
    label: string;
    /**
     * Return curve points for this fixed mix series.
     */
    data: Array<TacticMPOReturnCurveDataPoint>;
}
export namespace MPOReturnCurveSeriesResponseDTO {
    export type TypeEnum = 'OPTIMIZED_MIX' | 'REFERENCE_MIX';
    export const TypeEnum = {
        OptimizedMix: 'OPTIMIZED_MIX' as TypeEnum,
        ReferenceMix: 'REFERENCE_MIX' as TypeEnum
    };
}


